module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('v-container', {
    attrs: {
      "container--fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": "",
      "wrap": ""
    }
  }, [(_vm.post) ? _c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [(_vm.influencerData) ? _c('div', [_c('a', {
    attrs: {
      "href": _vm.influencerProfileURL,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [(_vm.influencerData.platform === 'linkedin') ? _c('v-icon', {
    attrs: {
      "color": "#0A66C2",
      "small": ""
    }
  }, [_vm._v("mdi-linkedin")]) : _vm._e(), _vm._v("\n                  @" + _vm._s(_vm.influencerData.username) + "\n              ")], 1)]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.post.campaignName) + " Campaign")])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-sm": "",
      "container--fluid": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": _vm.post.images.length === 0,
      "color": "info",
      "icon": "info",
      "outlined": ""
    }
  }, [_vm._v("\n                No Media found for this post.\n              ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "justify-space-around": ""
    }
  }, _vm._l((_vm.post.images), function(img, i) {
    return _c('v-flex', {
      key: i,
      attrs: {
        "md4": "",
        "xs12": ""
      }
    }, [(!img.isvideo) ? _c('v-card', {
      attrs: {
        "text": "",
        "tile": ""
      }
    }, [_c('a', {
      attrs: {
        "href": img.url,
        "download": "",
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "src": img.url,
        "contain": "",
        "max-height": "300"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (img.publicID && img.isvideo) ? _c('v-card', {
      attrs: {
        "text": "",
        "tile": ""
      }
    }, [_c('custom-media-v2', {
      attrs: {
        "media": _vm.campaignHelper.customPostMediaConfig(img, {
          videoDownload: true
        })
      }
    })], 1) : _c('v-card', {
      attrs: {
        "text": "",
        "tile": ""
      }
    }, [(img.isvideo) ? _c('div', {
      staticClass: "elevation-8"
    }, [_c('video', {
      attrs: {
        "id": "previewVideo",
        "width": "100%",
        "controls": ""
      }
    }, [_c('source', {
      attrs: {
        "src": img.url,
        "type": "video/mp4"
      }
    }), _vm._v("\n                        Your browser does not support the video tag.\n                      ")])]) : _vm._e()]), _vm._v(" "), (img.type === 'video/quicktime') ? _c('btn-download', {
      attrs: {
        "url": img.url
      }
    }) : _vm._e()], 1)
  }), 1)], 1), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "body-1"
  }, [_c('v-textarea', {
    attrs: {
      "readonly": "",
      "filled": "",
      "auto-grow": "",
      "label": "Caption",
      "value": _vm.post.captionText
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "body-1"
  }, [_c('v-textarea', {
    attrs: {
      "readonly": "",
      "filled": "",
      "auto-grow": "",
      "rows": "4",
      "label": "Kobe Remark",
      "counter": ""
    },
    model: {
      value: (_vm.post.remark),
      callback: function($$v) {
        _vm.$set(_vm.post, "remark", $$v)
      },
      expression: "post.remark"
    }
  })], 1), _vm._v(" "), (_vm.isVideoLink) ? _c('div', [(_vm.post.vdoLink) ? _c('div', {
    staticClass: "caption-text"
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "filled": "",
      "auto-grow": "",
      "label": "Link",
      "value": _vm.post.vdoLink
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.post.postDate) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('div', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-chip', {
    staticClass: "subtitle-1",
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("Scheduled Date: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.post.postDate))])])], 1)]) : _vm._e(), _vm._v(" "), _c('v-flex', [_c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('div', {
    staticClass: "subtitle-2"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("message")]), _vm._v("\n                      Internal Notes (for your internal communication only, neither Kobe nor the creators would have access to these notes)\n                    ")], 1)]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-container', [_c('chat-box', {
    attrs: {
      "label": "",
      "messages": _vm.clientMessages,
      "type": "internal_notes",
      "isClient": true
    },
    on: {
      "commented": _vm.sendClientMessage
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-space-between": "",
      "column": ""
    }
  }, [_c('v-flex', [_c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showStartQuestion),
      expression: "showStartQuestion"
    }],
    staticClass: "elevation-8"
  }, [(_vm.post.remark) ? _c('v-card-text', [_c('div', {
    staticClass: "body-1"
  }, [_c('v-textarea', {
    attrs: {
      "readonly": "",
      "filled": "",
      "auto-grow": "",
      "rows": "4",
      "label": "Kobe Remark",
      "counter": ""
    },
    model: {
      value: (_vm.post.remark),
      callback: function($$v) {
        _vm.$set(_vm.post, "remark", $$v)
      },
      expression: "post.remark"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "info",
      "outlined": ""
    }
  }, [_vm._v(_vm._s(_vm.notes.beforeStart))])], 1), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "text-center subtitle-1 font-weight-bold"
  }, [_vm._v("Is the Draft Approved?")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "dark": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        _vm.reviewSection = true, _vm.showStartQuestion = false
      }
    }
  }, [_vm._v("YES, APPROVE AND SCHEDULE")])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "small": "",
      "dark": "",
      "block": "",
      "text": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        _vm.reportSection = true, _vm.showStartQuestion = false
      }
    }
  }, [_vm._v("NO, REPORT ABUSE")])], 1)], 1)], 1), _vm._v(" "), (_vm.clientReportAbuse.length > 0) ? _c('v-flex', [_c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showReviewSummary),
      expression: "showReviewSummary"
    }],
    staticClass: "elevation-8"
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Post Review History")]), _vm._v(" "), _c('v-card-text', [_c('v-expansion-panels', _vm._l((_vm.clientReportAbuse), function(item, i) {
    return _c('v-expansion-panel', {
      key: i
    }, [_c('v-expansion-panel-header', [_vm._v("\n                      Review " + _vm._s(i + 1) + "\n                    ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card', [_c('v-card-text', {
      staticClass: "grey lighten-3"
    }, [_c('h4', [_vm._v("Reasons for Non-Approval")]), _vm._v(" "), _c('p', [_c('ol', _vm._l((item.reasons), function(r) {
      return _c('li', {
        key: r
      }, [_vm._v(_vm._s(r))])
    }), 0)]), _vm._v(" "), _c('h4', [_vm._v("Comments for Non-Approval:")]), _vm._v(" "), _c('p', [_vm._v("\n                            " + _vm._s(item.comment) + "\n                          ")]), _vm._v(" "), (item.files) ? _c('div', [_c('h4', [_vm._v("Uploaded Screenshots:")]), _vm._v(" "), _c('p', [_c('ol', _vm._l((item.files), function(f, index) {
      return _c('li', {
        key: index
      }, [_c('a', {
        attrs: {
          "href": f.url,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(_vm.utilsFunc.getFileNameFromURL(f.url)))])])
    }), 0)])]) : _vm._e()])], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.reviewSection) ? _c('v-card', [_c('v-form', [_c('v-card-text', {
    attrs: {
      "transition": "fade-transition"
    }
  }, [_c('div', {
    staticClass: "text-center title"
  }, [_c('v-icon', {
    attrs: {
      "color": "secondary",
      "size": "75"
    }
  }, [_vm._v("rate_review")]), _vm._v(" "), _c('p', [_vm._v("Rate & Review")])], 1), _vm._v(" "), _c('v-container', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "subtitle-1"
  }, [_vm._v("Kindly Rate Influencer's Quality of Work")]), _vm._v(" "), _c('v-rating', {
    attrs: {
      "color": "secondary",
      "size": "45"
    },
    model: {
      value: (_vm.submissionReview.approveRatings),
      callback: function($$v) {
        _vm.$set(_vm.submissionReview, "approveRatings", $$v)
      },
      expression: "submissionReview.approveRatings"
    }
  }), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submissionReview.approveRatings > 0 && _vm.submissionReview.approveRatings <= 4),
      expression: "submissionReview.approveRatings > 0 && submissionReview.approveRatings <= 4"
    }]
  }, [_c('p', {
    staticClass: "subtitle-1"
  }, [_c('v-textarea', {
    attrs: {
      "filled": "",
      "label": "How can we make this a 5 stars?"
    },
    model: {
      value: (_vm.submissionReview.approveSuggestion),
      callback: function($$v) {
        _vm.$set(_vm.submissionReview, "approveSuggestion", $$v)
      },
      expression: "submissionReview.approveSuggestion"
    }
  })], 1), _vm._v(" "), _c('v-divider')], 1)]), _vm._v(" "), _c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submissionReview.approveRatings > 0 && _vm.submissionReview.approveRatings == 5),
      expression: "submissionReview.approveRatings > 0 && submissionReview.approveRatings == 5"
    }]
  }, [_c('p', {
    staticClass: "subtitle-1"
  }, [_c('v-textarea', {
    attrs: {
      "filled": "",
      "label": "Leave Influencer a compliment?"
    },
    model: {
      value: (_vm.submissionReview.approveCompliment),
      callback: function($$v) {
        _vm.$set(_vm.submissionReview, "approveCompliment", $$v)
      },
      expression: "submissionReview.approveCompliment"
    }
  })], 1), _vm._v(" "), _c('v-divider')], 1)])], 1), _vm._v(" "), (_vm.post.postDate) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.post.propose_dates && _vm.askDate),
      expression: "!post.propose_dates && askDate"
    }]
  }, [_c('p', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                      Tentatively To go Live on\n                      "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.post.postDate))]), _vm._v(" ?\n                      "), _c('br'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "small": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        _vm.changeDate = true
      }
    }
  }, [_vm._v("No, Change Date")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "small": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        _vm.askDate = false
      }
    }
  }, [_vm._v("Yes, Date is Okay")])], 1)]), _vm._v(" "), (!_vm.askDate) ? _c('p', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                    Requested Date:\n                    "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.submissionReview.wantedLiveDate ? _vm.submissionReview.wantedLiveDate : _vm.post.postDate))]), _vm._v(" "), _c('v-icon', {
    on: {
      "click": function($event) {
        _vm.changeDate = true
      }
    }
  }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider')], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    ref: "dateDialog",
    attrs: {
      "return-value": _vm.submissionReview.wantedLiveDate,
      "persistent": "",
      "width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.submissionReview, "wantedLiveDate", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.submissionReview, "wantedLiveDate", $event)
      }
    },
    model: {
      value: (_vm.changeDate),
      callback: function($$v) {
        _vm.changeDate = $$v
      },
      expression: "changeDate"
    }
  }, [_c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "min": _vm.post.postDate,
      "allowed-dates": _vm.allowedDates
    },
    model: {
      value: (_vm.submissionReview.wantedLiveDate),
      callback: function($$v) {
        _vm.$set(_vm.submissionReview, "wantedLiveDate", $$v)
      },
      expression: "submissionReview.wantedLiveDate"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('v-alert', {
    staticStyle: {
      "margin-top": "-20px"
    },
    attrs: {
      "dense": "",
      "type": "info"
    }
  }, [_vm._v("\n                      Tentative live date indicated is assuming the earliest available date\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.changeDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": [_vm.saveWantedLiveDate, function($event) {
        $event.stopPropagation();
        _vm.askDate = false
      }]
    }
  }, [_vm._v("OK")])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('v-card-actions', [(_vm.showChangeRequest) ? _c('v-btn', {
    attrs: {
      "dark": "",
      "block": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.submitApprove()
      }
    }
  }, [_vm._v("Request Date Change")]) : _vm._e(), _vm._v(" "), (_vm.showApprove) ? _c('v-btn', {
    attrs: {
      "dark": "",
      "block": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        return _vm.submitApprove()
      }
    }
  }, [_vm._v("Approve")]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.reportSection) ? _c('v-card', [_c('v-form', [_c('v-card-text', [_c('div', {
    staticClass: "text-center title"
  }, [_c('v-icon', {
    attrs: {
      "color": "deep-orange",
      "size": "75"
    }
  }, [_vm._v("report_problem")]), _vm._v(" "), _c('p', [_vm._v("Report an Abuse")])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "container--fluid": ""
    }
  }, [_c('p', {
    staticClass: "subtitle-1"
  }, [_vm._v("1. Please select reasons for Non Approval")]), _vm._v(" "), _vm._l((_vm.abuseReasons), function(item, i) {
    return _c('v-checkbox', {
      key: i,
      attrs: {
        "label": item,
        "value": item,
        "height": "5"
      },
      model: {
        value: (_vm.submissionReview.abuseReasons),
        callback: function($$v) {
          _vm.$set(_vm.submissionReview, "abuseReasons", $$v)
        },
        expression: "submissionReview.abuseReasons"
      }
    })
  })], 2), _vm._v(" "), _c('v-container', [_c('p', {
    staticClass: "subtitle-1"
  }, [_vm._v("2. Comments for Abuse")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "filled": "",
      "auto-grow": ""
    },
    model: {
      value: (_vm.submissionReview.abuseComment),
      callback: function($$v) {
        _vm.$set(_vm.submissionReview, "abuseComment", $$v)
      },
      expression: "submissionReview.abuseComment"
    }
  })], 1), _vm._v(" "), _c('v-container', [_c('p', {
    staticClass: "subtitle-1"
  }, [_vm._v("3. Upload Screenshots")]), _vm._v(" "), _c('custom-file-upload', {
    attrs: {
      "refresh": _vm.fileUploadRefresh,
      "multiple": true
    },
    on: {
      "setMedias": _vm.updateFiles
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "block": "",
      "color": "deep-orange"
    },
    on: {
      "click": function($event) {
        return _vm.submitAbuse()
      }
    }
  }, [_vm._v("Submit Abuse")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.showStartQuestion) ? _c('v-btn', {
    attrs: {
      "block": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back_ios")]), _vm._v("Go Back\n        ")], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0544ab80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Post/SubmissionReview.vue
// module id = 1977
// module chunks = 0